import React from 'react';
import DataTable from '../DataTable/DataTable';
import * as helper from '../util/helper';

require('./DetailPage.scss');

class DetailPageRelativeView extends React.Component {
    constructor(props,context) {
        super(props,context);
    }

    getPageContext() {
        return {
            'DataId': this.props.detailPage.cmp_data.dataID,
            'currentDetailPageViewName': this.props.cmp_data.currentDetailPageViewName,
            'metaObjName': this.props.detailPage.cmp_data.metaObjectName,
            'viewName': this.props.detailPage.cmp_data.viewName
        };
    }

    renderContent() {
        const cmpType = this.props.sub_cmps[0] ? this.props.sub_cmps[0].cmp_type : '';
        switch(cmpType) {
            case 'TableList':
               return (
                   <DataTable ref="table"
                        cls='onepage_table_list_item'
                        {...this.props.sub_cmps[0]}
                        num={1}
                        title={this.props.cmp_data.title || ''}
                        queryUrl={helper.getQueryObject()} // this.props.query
                        actions={this.props.actions}
                        showTableTitle={true}
                        showColumn={5}
                        rowsLimit={4}
                        loadData={false}
                        tableAjaxParam={{ 'page_context': this.getPageContext() }}
                        disableRemberPosition={true}
                        noBottomButton={true}
                    />
               );
            default:
               return null;
        }
    }

    render() {
        return this.renderContent();
    }
}

export default DetailPageRelativeView;



// WEBPACK FOOTER //
// ./src/components/DetailPage/DetailPageRelativeView.js